import React from "react";
import styled from "styled-components";
import { Alert, Button, Space } from "antd";
import { WarningOutlined, CheckCircleOutlined, ReloadOutlined } from "@ant-design/icons";

const AlertContainer = styled.div`
  margin-bottom: 24px;
  border-radius: 8px;
  overflow: hidden;
`;

const PlatformStatusAlert = ({ platformStatus, onRefresh }) => {
  const isHealthy = platformStatus?.overall === "healthy";
  const whatsappDown = platformStatus?.whatsapp !== "online";
  const fleetIssues = platformStatus?.fleet !== "operational";
  const emailDown = platformStatus?.email !== "online";

  if (isHealthy) {
    return null; // Don't show alert when everything is operational
  }

  // Determine severity and message
  let severity = "warning";
  let message = "";
  let description = "";

  if (whatsappDown) {
    severity = "error";
    message = "⚠ WhatsApp Offline";
    description = "Quotes cannot be received. This is critical for operations.";
  } else if (emailDown) {
    severity = "error";
    message = "⚠ Email Not Configured";
    description =
      "Quote emails will not send. Check System health under Settings → Gmail / GOOGLE_SERVICE_ACCOUNT_KEY.";
  } else if (fleetIssues) {
    severity = "warning";
    message = "⚠ Fleet Issues Detected";
    description = "Some fleet services are experiencing problems.";
  }

  return (
    <AlertContainer>
      <Alert
        message={message}
        description={description}
        type={severity}
        icon={severity === "error" ? <WarningOutlined /> : <CheckCircleOutlined />}
        action={
          <Button
            size="small"
            icon={<ReloadOutlined />}
            onClick={onRefresh}
          >
            Refresh
          </Button>
        }
        showIcon
        closable={false}
        style={{
          borderRadius: 0,
          fontSize: "14px",
        }}
      />
    </AlertContainer>
  );
};

export default PlatformStatusAlert;

